var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('choose-component-transform-or-link',{attrs:{"items":_vm.types,"enable-categories":true,"categories":_vm.categories},on:{"next":function($event){return _vm.$emit("next")},"select":_vm.selectComponentType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }